<template>
  <el-dialog :close-on-click-modal="false" :visible.sync="isShow.isShow"
             append-to-body class="dashboard-steps" width="784px" @close="close">
    <template #title>
      <div v-if="isShow.action !== 'createTeamInfo'" class="el-dialog__title">{{ teamTitle }}</div>
      <div v-else class="el-dialog__title">{{ $t('teamDialog.title.node') }}</div>
    </template>
    <el-row v-if="isShow.action === 'modifyProjectInfo'">
      <el-col :span="3">{{ $t('teamDialog.form.teamId') }}</el-col>
      <el-col :span="21">
        <span>{{ projectId }}</span>
      </el-col>
    </el-row>
    <div v-if="isShow.action !== 'createTeamInfo'" class="step1">
      <el-row>
        <el-col :span="3">{{ $t('teamDialog.form.teamName') }}</el-col>
        <el-col :span="21">
          <el-input v-model="teamName" :placeholder="$t('teamDialog.form.inputPlaceholder')"
                    maxlength="60"
                    show-word-limit type="text"/>
        </el-col>
      </el-row>
    </div>
    <div v-else>
      <div>
        <createNode
          ref="createDialog"
          :closeDialog="closeDialog"
          :closeLoading="closeLoading"
          :isDoneDisabled="isDoneDisabled"
          :name="teamName"
          dialogType="createTeam"></createNode>
      </div>
    </div>
    <template #footer>
      <el-button
        key="done"
        :disabled="doneDisabled"
        :loading="isLoading"
        class="base-margin__left-10 done_width_100"
        type="primary"
        @click="done">
        {{ $t('teamDialog.button.done') }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import {mapGetters, mapState} from 'vuex';
import {postRequest} from '@/common/libs/request';
import createNode from '@/components/createNodeDialog';
import {nextTick} from 'vue';
import Cookies from 'js-cookie';
import {Base64} from 'js-base64';

export default {
  name: 'createTeamDialog',
  components: {
    createNode,
  },
  data() {
    return {
      btnLoading: false,
      isShow: {isShow: false, action: 'createTeam'},
      isLoading: false,
      teamName: '',
      doneDisabled: true,
      teamTitle: '',
      createModifyTeamLink: '',
      successTeam: '',
      approvalFile: '0',
      waterMarkRadio: '0',
      accountModel: 'nis',
      homePath: '/home',
      projectId: 0,
      mountList: [{src: '', dst: ''}],
    };
  },
  watch: {
    'app.teamIsShow'(val) {
      this.isShow = val;
      if (val.action === 'createTeam') {
        this.teamTitle = this.$t('teamDialog.title.create');
        this.createModifyTeamLink = '/api/eda/common/eda/createTeam';
        this.doneDisabled = false;
      }
      if (val.action === 'createTeamInfo') {
        this.doneDisabled = true;
        this.createNew();
      }
      if (val.action === 'modifyProjectInfo') {
        this.createModifyTeamLink = '/api/eda/common/project/modifyProjectInfo';
        this.teamTitle = this.$t('teamDialog.title.edit');
        this.projectId = Cookies.get('CurrentProjectId');
        this.getProjectInfo();
        this.doneDisabled = false;
      }
    },
  },
  computed: {
    ...mapState(['app']),
    ...mapGetters('app', ['getCurrentProject']),
  },
  created() {
    this.teamTitle = this.$t('teamDialog.title.create');
  },
  methods: {
    getProjectInfo() {
      postRequest('/api/eda/common/project/getProjectInfo').then((res) => {
        this.teamName = res.teamName;
        this.approvalFile = res?.settings?.approvalFile || '0';
        this.waterMarkRadio = res?.settings?.watermark || '0';
        this.accountModel = res?.settings?.accountModel || 'nis';
        this.homePath = res?.settings?.homePath || '/home';
        this.mountList = JSON.parse(Base64.decode(res?.settings?.mountList || '{}')).mount || [{src: '', dst: ''}];
      });
    },
    closeDialog() {
      this.doneDisabled = true;
      this.isLoading = false;
      this.close();
    },
    closeLoading() {
      this.isLoading = false;
    },
    isDoneDisabled(val) {
      this.doneDisabled = val;
    },
    createTeamName() {
      const mountList = this.mountList.filter(item => item.src !== '' && item.dst !== '');
      postRequest(this.createModifyTeamLink, {
        teamName: this.teamName,
        settings: {
          approvalFile: this.approvalFile.toString(),
          watermark: this.waterMarkRadio.toString(),
          accountModel: this.accountModel,
          homePath: this.homePath,
          mountList: Base64.encode(JSON.stringify({mount: mountList})),
        },
      }).then(async () => {
        await this.$message.success(this.$t('teamDialog.message.success', {action: this.teamTitle}));
        if (this.teamTitle !== this.$t('teamDialog.title.edit')) {
          await this.$store.dispatch('app/getProjectListSelectedNew');
          await this.$store.commit('app/setMenuSelectIndex', 1);
          if (this.$route.name !== 'computingCluster') {
            await this.$router.replace('computingCluster');
          }
        } else {
          await this.$store.dispatch('app/getProjectList');
        }
        await this.close();
      });
    },
    async done() {
      if (this.isShow.action !== 'createTeamInfo') {
        if (this.teamName === '') {
          this.$message.error(this.$t('teamDialog.form.emptyError'));
          return;
        }
        await this.createTeamName();
      } else {
        this.isLoading = true;
        await this.$refs.createDialog.createNode().then(() => {
          this.$store.commit('app/setCreateMasterNode', new Date().getTime());
        }).catch(() => {
          this.isLoading = false;
        });
      }
    },
    async createNew() {
      nextTick(() => {
        this.$refs.createDialog.createAdminNode('newMasterNode');
      });
    },
    close() {
      this.$store.commit('app/setTeamIsShow', {
        isShow: false,
        action: 'createTeam',
      });
      this.teamName = '';
      this.approvalFile = '0';
      this.waterMarkRadio = '0';
      this.accountModel = 'nis';
      this.homePath = '/home';
      this.thirdStepRuleForm = {
        model: '',
        auditor: '',
        diskSize: '',
        billingValue: 'POSTPAID_BY_HOUR',
        buyTime: 1,
        renew: 'NOTIFY_AND_AUTO_RENEW',
        price: '',
        zone: '',
        imageId: '',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.el-steps--horizontal {
  justify-content: center;
}

.el-steps {
  ::v-deep .el-step:nth-child(2) {
    flex-basis: 170px !important;
  }

  ::v-deep .el-step__icon {
    display: none;
  }

  ::v-deep .el-step__title {
    line-height: 22px;
  }

  ::v-deep .is-finish {
    //color: #2068DE;
    font-weight: 700;
    //border-color: #2068DE;
  }

  ::v-deep .is-process, .is-wait {
    color: #C0C4CC;
    font-weight: 400;
  }

  ::v-deep .el-step__head {
    position: absolute;
    width: 35%;
    right: 0;
  }

  ::v-deep .el-step__line {
    right: 19%;
  }
}

.dashboard-steps {
  ::v-deep .el-dialog__header {
    padding: 20px 35px;
  }

  ::v-deep .el-dialog__body {
    padding: 20px 35px;
  }

  ::v-deep .el-dialog__footer {
    padding: 20px 35px;
  }
}

.el-row {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
}

.step1 {
  font-size: 14px;
  line-height: 22px;

  p {
    color: rgba(0, 0, 0, 0.6);
  }

  p > span {
    //color: rgba(0,82,217,1);
    cursor: pointer;
  }

  h3 {
    color: #1A1A1A;
    font-weight: 400;
    font-size: 14px;
  }
}

.thirdStep {
  ::v-deep .el-form-item {
    margin-bottom: 16px;
  }

  ::v-deep .el-row {
    margin-bottom: 0;
  }

  .el-select {
    width: 100%;
  }

  ::v-deep .el-form-item__label:before {
    content: '' !important;
    margin: 0 !important;
  }
}

.el-button {
  padding: 0;
  height: 40px;
}

.done_width_100 {
  width: 70px;
}

.checkboxGroupCls {
  vertical-align: -6px;
  display: inline-block;
}
</style>
